module.exports = function() {
  return new Worker(__webpack_public_path__ + "43e524b981db51a0101f.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/workers/LoadManifestWorker.js
// module id = fJom
// module chunks = 170